import { z } from 'zod';

export const UserRecommendationsParamsDTO = z.object({
    locale: z.string(),
    pageId: z.union([z.literal('pdp'), z.literal('popUpBasket'), z.literal('homepage')]),
    productId: z.string().nullish(),
    deviceId: z.string().nullish(),
});

export type UserRecommendationsParamsDTO = z.infer<typeof UserRecommendationsParamsDTO>;
